// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Directory.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Container with Margins */

.page-container {
  margin: 0 auto;
  max-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
}

/* Faculty Directory Header */
.faculty-directory header {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  /* width: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: right;
  height: 400px;
  margin: 20px;
  color: rgba(255, 220, 220, 0.938);
 
}

/* Filter Section */
.filter-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.filter-section select,
.filter-section input {
  margin-top: 10px;
  padding: 8px;
  font-size: 14px;
}

.clear-button {
  padding: 8px 12px;
  background-color: #953942;
  color: white;
  border: none;
  cursor: pointer;
}

.clear-button:hover {
  background-color: #c82333;
}

/* Faculty Row (Three Columns) */
.faculty-row {
  display: flex;
  flex-wrap: wrap;
  gap: 13px; /* Space between columns */
  justify-content: space-between;
  margin: 0;
  padding: 0;
}

/* Faculty Member Card */
.faculty-member {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.33% - 20px); /* Three columns layout */
  max-width: calc(33.33% - 20px);
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1);
  text-align: center;
  box-sizing: border-box;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.faculty-member:hover {
  transform: translateY(-5px);
  box-shadow: 0 1px 20px 4px rgba(128, 128, 128, 0.327);
}

/* Faculty Info */
.faculty-image {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  object-fit: cover;
  margin: 20px auto;
}

.faculty-name {
  font-size: 20px;
  text-align: center;
  font-family: 'Raleway', sans-serif;
  font-weight: bold;
  color: #794a4a;
  margin-bottom: 1px;
}

.faculty-currentPortfolio  {
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
  text-align: leftr;
  color: #17064f;
  margin-bottom: 5px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 7px;
  line-height: 1.3;
}
.faculty-designation{
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  color: #17064f;
  text-align: left;
  margin-bottom: 5px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 7px;
  line-height: 1.3;
}
.faculty-department {
  font-family: 'Raleway', sans-serif;
  font-size: 13px;
  color: black;
  margin-bottom: 5px;
  text-align: left;
  font-weight: bold;
  margin-bottom: 7px;
  line-height: 1.3;
}
.alphabet-header {
  font-family: 'Raleway', sans-serif;
    font-weight: bold;
    font-size: 2.5em;
    color: black;
    text-align: left;
}

/* Contact Info */
.contact-info {
  font-family: 'Raleway', sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: #1057a1;
  margin-top: 10px;
  display: block;
  text-align: left;
}

.contact-info i {
  
  margin-right: 5px;

}
a {
  color: rgb(11, 10, 54);
 
}
.contact-info a {
  text-decoration: none;
  font-family: 'Raleway', sans-serif;
  color: inherit;
}

.contact-info a:hover {
  text-decoration: underline;
}

/* Responsive Design */

/* Two Columns for Medium Screens */
@media (max-width: 1024px) {
  .faculty-member {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 20px); /* Two columns layout */
    max-width: calc(50% - 20px);
  }
}

/* One Column for Small Screens */
@media (max-width: 768px) {
  .faculty-member {
    flex: 1 1 100%; /* Single column layout */
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FacultyDirectory.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAKhC;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE;2CAC+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,iCAAiC;;AAEnC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,0BAA0B;EACrC,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B,EAAE,yBAAyB;EACxD,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kCAAkC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;;AAEnB;AACA;EACE,sBAAsB;;AAExB;AACA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;;AAEtB,mCAAmC;AACnC;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,uBAAuB;IACnD,2BAA2B;EAC7B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,cAAc,EAAE,yBAAyB;IACzC,eAAe;EACjB;AACF","sourcesContent":["/* Page Container with Margins */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');\r\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap\");\r\n\r\n.page-container {\r\n  margin: 0 auto;\r\n  max-width: 1200px;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Faculty Directory Header */\r\n.faculty-directory header {\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\r\n    url('./images/Directory.png');\r\n  background-size: cover;\r\n  background-position: center;\r\n  /* width: 100%; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  text-align: right;\r\n  height: 400px;\r\n  margin: 20px;\r\n  color: rgba(255, 220, 220, 0.938);\r\n \r\n}\r\n\r\n/* Filter Section */\r\n.filter-section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-bottom: 30px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filter-section select,\r\n.filter-section input {\r\n  margin-top: 10px;\r\n  padding: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.clear-button {\r\n  padding: 8px 12px;\r\n  background-color: #953942;\r\n  color: white;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.clear-button:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n/* Faculty Row (Three Columns) */\r\n.faculty-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 13px; /* Space between columns */\r\n  justify-content: space-between;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Faculty Member Card */\r\n.faculty-member {\r\n  flex: 1 1 calc(33.33% - 20px); /* Three columns layout */\r\n  max-width: calc(33.33% - 20px);\r\n  background-color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(255, 255, 255, 0.1);\r\n  text-align: center;\r\n  box-sizing: border-box;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.faculty-member:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 1px 20px 4px rgba(128, 128, 128, 0.327);\r\n}\r\n\r\n/* Faculty Info */\r\n.faculty-image {\r\n  width: 170px;\r\n  height: 170px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  margin: 20px auto;\r\n}\r\n\r\n.faculty-name {\r\n  font-size: 20px;\r\n  text-align: center;\r\n  font-family: 'Raleway', sans-serif;\r\n  font-weight: bold;\r\n  color: #794a4a;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n.faculty-currentPortfolio  {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 12px;\r\n  text-align: leftr;\r\n  color: #17064f;\r\n  margin-bottom: 5px;\r\n  text-align: left;\r\n  font-weight: bold;\r\n  margin-bottom: 7px;\r\n  line-height: 1.3;\r\n}\r\n.faculty-designation{\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 14px;\r\n  color: #17064f;\r\n  text-align: left;\r\n  margin-bottom: 5px;\r\n  text-align: left;\r\n  font-weight: bold;\r\n  margin-bottom: 7px;\r\n  line-height: 1.3;\r\n}\r\n.faculty-department {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 13px;\r\n  color: black;\r\n  margin-bottom: 5px;\r\n  text-align: left;\r\n  font-weight: bold;\r\n  margin-bottom: 7px;\r\n  line-height: 1.3;\r\n}\r\n.alphabet-header {\r\n  font-family: 'Raleway', sans-serif;\r\n    font-weight: bold;\r\n    font-size: 2.5em;\r\n    color: black;\r\n    text-align: left;\r\n}\r\n\r\n/* Contact Info */\r\n.contact-info {\r\n  font-family: 'Raleway', sans-serif;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  color: #1057a1;\r\n  margin-top: 10px;\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n.contact-info i {\r\n  \r\n  margin-right: 5px;\r\n\r\n}\r\na {\r\n  color: rgb(11, 10, 54);\r\n \r\n}\r\n.contact-info a {\r\n  text-decoration: none;\r\n  font-family: 'Raleway', sans-serif;\r\n  color: inherit;\r\n}\r\n\r\n.contact-info a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Responsive Design */\r\n\r\n/* Two Columns for Medium Screens */\r\n@media (max-width: 1024px) {\r\n  .faculty-member {\r\n    flex: 1 1 calc(50% - 20px); /* Two columns layout */\r\n    max-width: calc(50% - 20px);\r\n  }\r\n}\r\n\r\n/* One Column for Small Screens */\r\n@media (max-width: 768px) {\r\n  .faculty-member {\r\n    flex: 1 1 100%; /* Single column layout */\r\n    max-width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
